import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';

import EditShiftModalWithRecord from './EditShiftModalWithRecord';
import EditShiftModalWithoutRecord from './EditShiftModalWithoutRecord';
import { shiftLable } from 'common/state_mapping';

import { attempConfirmRecord } from 'actions/UserActions';

export default class EditShiftModal extends Component {
  handleConfirm = (confirm=true) => {
    let uid = this.props.record && this.props.record.get('uid');
    uid = uid || 0;
    let {date, sid} = this.props;
    return () => {
      this.props.dispatch(attempConfirmRecord(uid, date.format("YYYY-MM-DD"), sid, confirm));
    }
  }

  render() {
    let {dismiss, date, sid, record, switchToCreateModal} = this.props;
    let dateStr = date.format("YYYY-MM-DD");
    let hasRecord = (record === undefined ? false : true);
    let hasChecked = (hasRecord? record.get('checkRecords').get(0).get('checkAt') !== null: false);
    let hasAssign = (hasRecord? (record.get("cid") !== 0 && record.get("cid") !== null): false);
    let abledToConfirm = (hasRecord? (record.get("cid") > 0 && record.get("cid") !== null): false);
    let hasConfirmed = (hasRecord? record.get('confirmAt') !== null : false);
    hasRecord = (hasAssign || hasChecked);
    let validCheckedin = true;

    if (hasChecked) {
      validCheckedin = record.getIn(['checkRecords', 0, 'status'])
      if (record.get('checkRecords').size > 1) 
        validCheckedin = validCheckedin || record.getIn(['checkRecords', 1, 'status'])
    }
    validCheckedin = validCheckedin !== 1;

    const ConfirmBtn = (
      <button
        className={"btn btn-" + (hasConfirmed ? "primary":"default")}
        disabled={!abledToConfirm || !validCheckedin}
        onClick={this.handleConfirm(!hasConfirmed)}
      >
        <span className="glyphicon glyphicon-lock"></span>
        {" "}確認出席
      </button>
    )

    return (
      <Modal.Dialog className="schedule__edit__modal">
        <Modal.Header>
          <Modal.Title>
            記錄詳情
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="shift-date">
            <span className="label label-primary">{shiftLable[sid]}</span>
            {dateStr}
            <button className="btn btn-default btn-xs" onClick={switchToCreateModal}>修改多日記錄</button>
          </div>
          {!hasRecord && <EditShiftModalWithoutRecord {...this.props} />}
          {hasRecord && <EditShiftModalWithRecord {...this.props} />}
        </Modal.Body>
        <Modal.Footer>
          {hasRecord && ConfirmBtn}
          <button className="btn btn-default" onClick={dismiss}>關閉</button>
        </Modal.Footer>
      </Modal.Dialog>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Schedule/EditShiftModal.js